var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-icon',{attrs:{"icon":['quality', _vm.quality],"fixed-width":_vm.fixedWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }